import { AddressType } from './enums/address-type';
import { GenericObject } from './generic-object';
import { PortalVisibility } from './enums/portal-visibility';
import { UsageType } from './enums/usage-type';
import { copyFields } from './utils/copy-fields';

export class Address {
    public id!: number;
    public street!: string;
    public number!: string;
    public zip!: string;
    public country?: string;
    /** Two-letter ISO code, for tight columns. */
    public countryCode?: string;
    public city!: string;
    public title?: string;
    public note?: string;
    public isInvoiceAddress!: boolean;
    public isDeliveryAddress!: boolean;
    public isMainAddress!: boolean;
    public isDefaultAddress!: boolean;
    public originalAddressId!: number;
    public visibility!: PortalVisibility;
    public usageType?: UsageType;
    public type?: AddressType;
    public addition?: string;
    public costCentre?: string;

    public static fromPlainObject(object: GenericObject): Address {
        const address = new Address();

        copyFields(object, address);

        if (object['originalAddressId']) {
            address.id = object['originalAddressId'];
        }

        return address;
    }
}
